module.exports = __webpack_public_path__ + "static/media/zegar.127ac5b5.svg";